<template>
  <div>
    <splitpanes class="default-theme" :size="10">
      <pane max-size="15" v-bind:style="{ float: 'left', height: clientHeight, 'overflow-y': 'auto' }">
        <tree :data="fuelTanksTree" @node:selected="onNodeSelected" ref="treeComponentKey" style="font-size: 12px;"></tree>
      </pane>
      <pane>
        <GmapMap style="position: fixed; width: 100%; height: 100%" ref="mapRef" v-bind="options">
          <GmapMarker
            v-for="m in markers"
            :key="m.id"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            @mouseover="onMarkerMouseOver(m.id)"
            @mouseout="onMarkerMouseOut(m.id)"
          />
          <GmapInfoWindow
            @closeclick="infoWindow.isOpen=false"
            :opened="infoWindow.isOpen"
            :position="infoWindow.position"
            :content="infoWindow.content"
            :options="infoWindow.options"
          ></GmapInfoWindow>
        </GmapMap>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
import { utilsService } from "../../../services";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import LiquorTree from "liquor-tree";

export default {
  name: "FuelTanksMaps",
  components: {
    Splitpanes, 
    Pane,
    [LiquorTree.name]: LiquorTree
  },
  props: {
    fuelTanksInfo: Array,
    fuelTanks: Array
  },
  data: () => ({
    options: {
      center: { lat: 48.7526, lng: 33.218 },
      zoom: 6,
      options: {
        mapTypeId: "roadmap",
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: 2,
          position: 1,
          mapTypeIds: ["roadmap", "terrain", "satellite", "hybrid"]
        },
        zoomControl: true,
        zoomControlOptions: {
          position: 1
        },
        scaleControl: true
      }
    },
    infoWindow: {
      isOpen: false,
      position: null,
      content: null,
      options: {
        pixelOffset: {
          width: 0,
          height: -45
        },
        minWidth: 800,
        content: null
      }
    }
  }),
  computed: {
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 70;

      return `${document.documentElement.clientHeight -
        FUEL_TANKS_POSITION_Y}px`;
    },
    markers () {
      const markers = [];

      if (this.fuelTanksInfo == null || this.fuelTanks == null) {
        return markers;
      }


      const columns = this.$store.state.localization.data.mainPage.fuelTanks
        .tableColumns;

      for (let i = 0; i < this.fuelTanksInfo.length; i++) {
        let tooltips = [];

        markers.push({
          id: this.fuelTanksInfo[i].vehicleId,
          position: {
            lat: this.fuelTanksInfo[i].latitude,
            lng: this.fuelTanksInfo[i].longitude
          },
          label: {
            fontSize: "13px"
          },
          tooltip: ""
        });

        const vehicle = this.fuelTanks.find(item => {
          return item.vehicleId == this.fuelTanksInfo[i].vehicleId;
        });

        tooltips.push("<div>");
        tooltips.push(
          `<h6>${this.$store.state.localization.data.mainPage.fuelTanks.tableColumns.companyName}: ${vehicle.companyName}; ${this.$store.state.localization.data.mainPage.fuelTanks.tableColumns.depoName}: ${vehicle.depoName}</h6>`
        );

        tooltips.push("<table border='1'>");

        tooltips.push("<thead>");
        tooltips.push("<tr>");

        tooltips.push(
          `<th style='text-align:center'>${columns.fuelTankName}</th>`
        );
        tooltips.push(`<th style='text-align:center'>${columns.fuelType}</th>`);
        tooltips.push(`<th style='text-align:center'>${columns.time}</th>`);
        tooltips.push(
          `<th style='text-align:center'>${columns.fuelVolume}</th>`
        );
        tooltips.push(
          `<th style='text-align:center'>${columns.fuelVolumeFree}</th>`
        );
        tooltips.push(
          `<th style='text-align:center'>${columns.fuelVolumePercent}</th>`
        );
        tooltips.push(
          `<th style='text-align:center'>${columns.fuelWeight}</th>`
        );
        tooltips.push(
          `<th style='text-align:center'>${columns.fuelTemperature}</th>`
        );
        tooltips.push(
          `<th style='text-align:center'>${columns.fuelDensity}</th>`
        );
        // tooltips.push(
        //   `<th style='text-align:center'>${columns.waterVolume}</th>`
        // );

        tooltips.push("</tr>");
        tooltips.push("</thead>");

        tooltips.push("<tbody>");

        let fuelVolume = 0,
          fuelWeight = 0,
          fuelVolumeFree = 0,
          fuelTemperature = 0,
          fuelDensity = 0;
          // waterVolume = 0;

        for (let j = 0; j < this.fuelTanksInfo[i].fuelTanks.length; j++) {
          const fuelTank = this.fuelTanks.find(item => {
            return (
              item.vehicleId == this.fuelTanksInfo[i].vehicleId &&
              item.fuelTankId == this.fuelTanksInfo[i].fuelTanks[j].fuelTankId
            );
          });

          if (!fuelTank) {
            continue;
          }

          tooltips.push("<tr>");

          tooltips.push(
            `<td style='text-align:center'>${fuelTank.fuelTankName}</td>`
          );

          tooltips.push(
            `<td style='text-align:center'>${fuelTank.fuelType}</td>`
          );

          const time = new Date(this.fuelTanksInfo[i].fuelTanks[j].time * 1000);

          tooltips.push(
            `<td style='text-align:center'>${utilsService.formatDateTime(
              time,
              utilsService.DATE_TIME_FORMAT
            )}</td>`
          );

          tooltips.push(
            `<td style='text-align:center'>${utilsService.formatNumber(
              this.fuelTanksInfo[i].fuelTanks[j].fuelVolume,
              1
            )}</td>`
          );
          fuelVolume += this.fuelTanksInfo[i].fuelTanks[j].fuelVolume;

          tooltips.push(
            `<td style='text-align:center'>${utilsService.formatNumber(
              this.fuelTanksInfo[i].fuelTanks[j].fuelVolumeFree,
              1
            )}</td>`
          );
          fuelVolumeFree += this.fuelTanksInfo[i].fuelTanks[j].fuelVolumeFree;

          tooltips.push(
            `<td style='text-align:center'>${utilsService.formatNumber(
              this.fuelTanksInfo[i].fuelTanks[j].fuelVolumePercent,
              2
            )}</td>`
          );

          tooltips.push(
            `<td style='text-align:center'>${utilsService.formatNumber(
              this.fuelTanksInfo[i].fuelTanks[j].fuelWeight,
              1
            )}</td>`
          );
          fuelWeight += this.fuelTanksInfo[i].fuelTanks[j].fuelWeight;

          tooltips.push(
            `<td style='text-align:center'>${utilsService.formatNumber(
              this.fuelTanksInfo[i].fuelTanks[j].fuelTemperature,
              1
            )}</td>`
          );
          fuelTemperature += this.fuelTanksInfo[i].fuelTanks[j].fuelTemperature;

          tooltips.push(
            `<td style='text-align:center'>${utilsService.formatNumber(
              this.fuelTanksInfo[i].fuelTanks[j].fuelDensity,
              3
            )}</td>`
          );
          fuelDensity += this.fuelTanksInfo[i].fuelTanks[j].fuelDensity;

          // tooltips.push(
          //   `<td style='text-align:center'>${utilsService.formatNumber(
          //     this.fuelTanksInfo[i].fuelTanks[j].waterVolume,
          //     1
          //   )}</td>`
          // );
          // waterVolume += this.fuelTanksInfo[i].fuelTanks[j].waterVolume;

          tooltips.push("</tr>");
        }

        tooltips.push("</tbody>");

        tooltips.push("<tfoot style='font-weight: bold'>");
        tooltips.push("<tr>");
        tooltips.push("<td></td>");
        tooltips.push("<td></td>");
        tooltips.push("<td></td>");
        tooltips.push(
          `<td style='text-align:center'>${utilsService.formatNumber(
            fuelVolume,
            1
          )}</td>`
        );
        tooltips.push(
          `<td style='text-align:center'>${utilsService.formatNumber(
            fuelVolumeFree,
            1
          )}</td>`
        );
        tooltips.push(
          `<td style='text-align:center'>${utilsService.formatNumber(
            (100 * fuelVolume) / (fuelVolumeFree + fuelVolume),
            2
          )}</td>`
        );
        tooltips.push(
          `<td style='text-align:center'>${utilsService.formatNumber(
            fuelWeight,
            1
          )}</td>`
        );
        tooltips.push(
          `<td style='text-align:center'>${utilsService.formatNumber(
            fuelTemperature / this.fuelTanksInfo[i].fuelTanks.length,
            1
          )}</td>`
        );
        tooltips.push(
          `<td style='text-align:center'>${utilsService.formatNumber(
            fuelDensity / this.fuelTanksInfo[i].fuelTanks.length,
            3
          )}</td>`
        );
        // tooltips.push(
        //   `<td style='text-align:center'>${utilsService.formatNumber(
        //     waterVolume,
        //     1
        //   )}</td>`
        // );
        tooltips.push("</tr>");
        tooltips.push("</tfoot>");

        tooltips.push("</table>");
        tooltips.push("</div>");

        markers[markers.length - 1].tooltip = tooltips.join("");
      }

      return markers;
    },
    fuelTanksTree() {
      const fuelTanksTree = [];

      if (this.fuelTanks == null) {
        return fuelTanksTree;
      }

      for (let i = 0; i < this.fuelTanks.length; i++) {
        let company = fuelTanksTree.find(item => {
          return item.text == this.fuelTanks[i].companyName;
        });

        if (!company) {
          company = {
            text: this.fuelTanks[i].companyName,
            children: [],
            state: {
              expanded: true
            }
          };
          fuelTanksTree.push(company);
        }

        let depo = company.children.find(item => {
          return item.text == this.fuelTanks[i].depoName;
        });

        if (!depo) {
          depo = {
            text: this.fuelTanks[i].depoName,
            children: []
          };

          company.children.push(depo);
        }

        depo.children.push({
          text: this.fuelTanks[i].fuelTankName,
          data: {
            vehicleId: this.fuelTanks[i].vehicleId
          },
          state: {
            editable: false,
            draggable: false,
            dropable: false
          }
        });
      }

      //we need to set manually data, because 'data' property of tree is not reactive
      this.$refs.treeComponentKey.tree.setModel(fuelTanksTree);

      return fuelTanksTree;
    }
  },
  methods: {
    onMarkerMouseOver(id) {
      const marker = this.markers.find(item => item.id == id);

      this.infoWindow.options.content = marker.tooltip;
      this.infoWindow.position = marker.position;
      this.infoWindow.isOpen = true;
    },
    onMarkerMouseOut() {
      this.infoWindow.isOpen = false;
    },
    async showFuelTank(vehicleId) {
      const marker = this.markers.find(item => {
        return (item.id == vehicleId);
      });

      const map = await this.$refs.mapRef.$mapPromise;

      map.setZoom(12);
      map.panTo(marker.position);

      this.onMarkerMouseOver(vehicleId);
    },
    async onNodeSelected(node) {
      if (node.data && node.data.vehicleId) {
        await this.showFuelTank(node.data.vehicleId);
      }
    }
  }
};
</script>


